import { runInInjectionContext, Injector } from '@angular/core';
import { WcgTableValues } from '@shared/interfaces/wcg-table-utils.interface';
import { WcgTimeOnlyPipe } from '@wcg/frontend-framework';

export function buildExportData(
  wcgTableValues: WcgTableValues,
  type: string,
  injector: Injector,
): WcgTableValues {
  return runInInjectionContext(injector, () => {
    const _wcgTimeOnlyPipe = injector.get(WcgTimeOnlyPipe);
    const currentTime = _wcgTimeOnlyPipe.transform(new Date());
    const timezoneName = currentTime.split(' ')[1];

    return {
      ...wcgTableValues,
      is_export: true,
      export_type: type,
      timezone_name: timezoneName,
    };
  });
}
